import React, { useState } from "react";

// استيراد الداشبوردز
import BookingDashboard from "./BookingDashboard";
import ServicesDashboard from "./ServicesDashboard";
import TeamDashboard from "./TeamDashboard";
import LibraryDashboard from "./LibraryDashboard";
import AboutDashboard from "./AboutDashboard";

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("bookings");

  const renderContent = () => {
    switch (activeTab) {
      case "bookings":
        return <BookingDashboard />;
      case "services":
        return <ServicesDashboard />;
      case "team":
        return <TeamDashboard />;
      case "library":
        return <LibraryDashboard />;
      case "about":
        return <AboutDashboard />;
      default:
        return <BookingDashboard />;
    }
  };

  return (
    <div className="admin-wrapper">
      {/* القائمة الجانبية */}
      <aside className="admin-sidebar">
        <div className="admin-logo">لوحة التحكم</div>
        <nav className="admin-nav">
          <button
            className={activeTab === "bookings" ? "active" : ""}
            onClick={() => setActiveTab("bookings")}
          >
            📅 الحجوزات
          </button>
          <button
            className={activeTab === "services" ? "active" : ""}
            onClick={() => setActiveTab("services")}
          >
            ⚖️ الخدمات
          </button>
          <button
            className={activeTab === "team" ? "active" : ""}
            onClick={() => setActiveTab("team")}
          >
            👥 فريق العمل
          </button>
          <button
            className={activeTab === "library" ? "active" : ""}
            onClick={() => setActiveTab("library")}
          >
            📚 المدونة
          </button>
          <button
            className={activeTab === "about" ? "active" : ""}
            onClick={() => setActiveTab("about")}
          >
            ℹ️ من نحن
          </button>
        </nav>
      </aside>

      {/* المحتوى الرئيسي */}
      <main className="admin-content">{renderContent()}</main>
    </div>
  );
};

export default AdminPanel;
